import { faUserDoctor } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * Provider item interface for ui_metadata storage
 */
export interface ProviderItem {
  id: string;
  displayLabel: string;
  provider_id: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  specialty?: string;
}

/**
 * Get display name for a provider (handles both name and first_name/last_name formats)
 */
export const getProviderDisplayName = (provider: ProviderItem): string => {
  return provider.name || `${provider.first_name || ''} ${provider.last_name || ''}`.trim() || provider.provider_id;
};

/**
 * Transform API response to ProviderItem format
 */
export const transformProvider = (apiItem: {
  provider_id: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  specialty?: string;
}): ProviderItem => {
  const displayLabel = apiItem.name || `${apiItem.first_name || ''} ${apiItem.last_name || ''}`.trim() || apiItem.provider_id;
  return {
    id: apiItem.provider_id,
    displayLabel,
    provider_id: apiItem.provider_id,
    name: apiItem.name,
    first_name: apiItem.first_name,
    last_name: apiItem.last_name,
    specialty: apiItem.specialty,
  };
};

/**
 * Modal configuration for Provider selector
 */
export const providerModalConfig: GenericSelectorModalConfig<ProviderItem> = {
  title: 'Select Providers',
  searchPlaceholder: 'Search providers by name, specialty, or location...',
  emptyStateIcon: faUserDoctor,
  emptyStateMessage: 'No providers selected',
  noResultsMessage: (searchTerm) => `No providers found for "${searchTerm}"`,
  colorTheme: 'blue',
  selectionMode: 'multiple',
  showConnectorToggle: true,
  defaultConnector: 'ANY',
  getItemLabel: (item) => getProviderDisplayName(item),
  getItemSecondaryLabel: (item) => item.specialty || null,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'provider',
  itemLabelPlural: 'providers',
};

/**
 * Node display configuration for Provider
 */
export const providerNodeConfig: GenericNodeComponentConfig<ProviderItem> = {
  colorTheme: 'blue',
  getItemLabel: (item) => getProviderDisplayName(item),
  getItemKey: (item) => item.id,
  maxVisibleItems: 2,
  showConnectorLabel: true,
};
